import React, { useState } from "react";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { dateTimeToView } from "../../../../utils/date.utils";
import { routeName } from "../../../../routes/routeName";
import { icons } from "../../../../assets/icons/icons";
import CustomStatus from "../../../../components/chip/CustomStatus";
import { FiberManualRecord } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface ListAdvisoryRequestProps {
  data: any;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  totalItems: number;
  sortBy: string;
  sortType: string;
  pageLimit: number;
  setPageLimit: React.Dispatch<React.SetStateAction<number>>;
}

const ListAdvisoryRequest: React.FC<ListAdvisoryRequestProps> = ({
  data,
  page,
  setPage,
  totalItems,
  sortBy,
  sortType,
  pageLimit,
  setPageLimit,
}) => {
  const { t } = useTranslation();
  console.log("page", page);
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const headCells = [
    {
      id: "fullname",
      width: 50,
      disablePadding: true,
      align: "start",
      label: t("ชื่อ - นามสกุล"),
    },
    {
      id: "nickname",
      disablePadding: true,
      width: 15,
      align: "center",
      label: t("ฉายา"),
    },
    {
      id: "student_no",
      disablePadding: false,
      align: "center",
      width: 15,
      label: t("รหัสประจำตัวนักศึกษา"),
    },
    {
      id: "degree",
      disablePadding: false,
      align: "center",
      width: 15,
      label: t("ระดับ"),
    },
    {
      id: "course",
      disablePadding: false,
      align: "center",
      width: 15,
      label: t("หลักสูตร"),
    },
    {
      id: "year",
      disablePadding: false,
      align: "center",
      width: 50,
      label: t("ชั้นปีที่"),
    },
    {
      id: "date_request",
      disablePadding: false,
      align: "center",
      width: 20,
      label: t("วันที่ส่งคำขอ"),
    },
    {
      id: "status",
      disablePadding: false,
      align: "center",
      width: 20,
      label: t("สถานะ"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "action",
    },
  ];

  const handleStatus = (status: string) => {
    if (status === "รอพิจารณา") { // i18n-ignore
      return "warning";
    } else if (status === "ตอบรับเป็นที่ปรึกษา") { // i18n-ignore
      return "success";
    } else if (status === "ปฏิเสธคำขอ") { // i18n-ignore
      return "error";
    } else if (status === "รออาจารย์ที่ปรึกษาพิจารณาคำร้อง") { // i18n-ignore
      return "warning";
    } else if (status === "รออาจารย์ที่ปรึกษาใหม่พิจารณาคำร้อง") { // i18n-ignore
      return "warning";
    } else if (status === "สิ้นสุดการเป็นอาจารย์ที่ปรึกษา") { // i18n-ignore
      return "error";
    } else {
      return "default";
    }
  };

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_advisor_request,
      student_frist_name,
      student_last_name,
      student_nickname,
      student_no,
      education_type_name,
      faculty_name,
      dg_degree_name,
      grade_level,
      year,
      created_date,
      status,
      status_request,
    } = objData;

    const objRenderData = {
      key: id_advisor_request,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: student_frist_name + " " + student_last_name,
        },
        {
          option: "TEXT",
          align: "start",
          label: student_nickname,
        },
        {
          option: "TEXT",
          align: "center",
          label: student_no,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: dg_degree_name ?? '',
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: faculty_name,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: grade_level ?? null,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: created_date ? dateTimeToView(created_date) : "",
        },
        {
          option: "TEXT",
          align: "center",
          // label: status_request,
          label: (
            <CustomStatus
              label={t(status_request)}
              type="outlined"
              color={handleStatus(status_request)}
              icon={<FiberManualRecord />}
              width="250px"
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  navigate(
                    routeName.cms.manageAdvisors +
                      `/${id_advisor_request}/request/detail?advisor_id=${id}`
                  );
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  console.log("data", data);

  return (
    <section className="w-full mt-10">
      <TableCustom
        tableMinWidth={2000}
        tableFixedWidth
        customScroll
        page={page}
        pageLimit={pageLimit}
        sortBy={sortBy}
        sortType={sortType}
        headCells={headCells}
        rowCount={totalItems}
        rowsData={
          data &&
          data.length > 0 &&
          data.map((data: any, i: any) => {
            return renderData(data, i);
          })
        }
        onSort={() => {}}
        setPageLimit={(value: number) => setPageLimit(value)}
        setPage={(value: number) => setPage(value)}
      />
    </section>
  );
};

export default ListAdvisoryRequest;
